/**
 * 常量
 * 
*/

export const ELECTRIC_DATA = 'electric/ELECTRIC_DATA';
export const ELECTRIC_HISTORY = 'electric/ELECTRIC_HISTORY';
export const ELECTRIC_DEMAND = 'electric/ELECTRIC_DEMAND';

